<template>
    <div class="titlepicture" :style="{ 'background': 'url(' + require('../../assets/img/'+bgimg) + ') no-repeat center center'}">
        <div v-html="text"></div>
    </div>
</template>
<script>
export default {
    props:{
        text:{
            type:String
        },
        bgimg:{
            type:String
        }
    }
}
</script>

<style scoped>
.titlepicture{
    height: 350px;
    color: #fff;
    font-size: 48px;
    text-align: center;
    line-height: 350px;
    font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/components/common/titlepicture.vue